import apiClient from '../index';

export const eventThemeApi = {
  // GET /api/event-themes — List all event themes
  getEventThemes: () => apiClient.get('/event-themes'),

  // POST /api/event-themes — Create event theme
  createEventTheme: (data) => apiClient.post('/event-themes', data),

  // GET /api/event-themes/{id} — Show single event theme
  getEventTheme: (id) => apiClient.get(`/event-themes/${id}`),

  // PUT /api/event-themes/{id} — Update event theme
  updateEventTheme: (id, data) => apiClient.put(`/event-themes/${id}`, data),

  // DELETE /api/event-themes/{id} — Delete event theme
  deleteEventTheme: (id) => apiClient.delete(`/event-themes/${id}`),

  // GET /api/event/custom-websites — List available custom website options
  getCustomWebsites: () => apiClient.get('/event/custom-websites'),

  // POST /api/event/theme-settings — Save theme settings for the current event
  // Fields: primary_color (required), secondary_color (required), tertially_color (required), custom_website_id (nullable int)
  saveThemeSettings: (data) => apiClient.post('/event/theme-settings', data),
};

export default eventThemeApi;
